import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { writable } from 'svelte/store';

const firebaseConfig = {
  apiKey: "AIzaSyDlyHOLm1HQLUfYMOdBZUw1RIZe7_Uv4I4",
  authDomain: "portfolio-58cef.firebaseapp.com",
  projectId: "portfolio-58cef",
  storageBucket: "portfolio-58cef.firebasestorage.app",
  messagingSenderId: "925585604736",
  appId: "1:925585604736:web:93b8740c24546728e56665",
  measurementId: "G-HL0MJ5Y4PL",
};

const app = initializeApp(firebaseConfig);


const analytics = writable(null);

if (typeof window !== 'undefined') {
  analytics.set(getAnalytics(app));
}

export { analytics, app };

export const logEvent = (eventName, eventParams) => {
  import('firebase/analytics').then(({ logEvent }) => {
    analytics.subscribe(analyticsInstance => {
      if (analyticsInstance) {
        logEvent(analyticsInstance, eventName, eventParams);
      }
    })();
  });
};

